export const initialState = ({
  id,
  code,
  description,
  isAvailable = true,
  title,
  price = 0,
  discount = 0,
  token,
  category,
  images,
  links = [],
} = {}) => ({
  id,
  title,
  token,
  price,
  discount,
  code,
  description,
  isAvailable,
  images,
  isEditMode: !!id,
  categoriesIsVisible: false,
  category,
  linksIsVisible: false,
  links,
  selectedLink: null,
});

export const types = {
  SET_TITLE: 'SET_TITLE',
  SET_TOKEN: 'SET_TOKEN',
  SET_PRICE: 'SET_PRICE',
  SET_DISCOUNT: 'SET_DISCOUNT',
  SET_CODE: 'SET_CODE',
  SET_DESCRIPTION: 'SET_DESCRIPTION',
  SET_IS_AVAILABLE: 'SET_IS_AVAILABLE',
  SET_CATEGORY: 'SET_CATEGORY',
  SET_IMAGES: 'SET_IMAGES',
  SET_LINKS: 'SET_LINKS',
  SET_LINKS_IS_VISIBLE: 'SET_LINKS_IS_VISIBLE',
  SET_CATEGORIES_IS_VISIBLE: 'SET_CATEGORIES_IS_VISIBLE',
  SET_SELECTED_LINK: 'SET_SELECTED_LINK',
  SET_MULTI: 'SET_MULTI',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_TITLE:
      return { ...state, title: payload };
    case types.SET_PRICE:
      return { ...state, price: payload };
    case types.SET_DISCOUNT:
      return { ...state, discount: payload };
    case types.SET_TOKEN:
      return { ...state, token: payload };
    case types.SET_CODE:
      return { ...state, code: payload };
    case types.SET_DESCRIPTION:
      return { ...state, description: payload };
    case types.SET_IS_AVAILABLE:
      return { ...state, isAvailable: payload };
    case types.SET_IMAGES:
      return { ...state, images: payload };
    case types.SET_LINKS_IS_VISIBLE:
      return { ...state, linksIsVisible: payload };
    case types.SET_LINKS:
      return { ...state, links: payload };
    case types.SET_SELECTED_LINK:
      return { ...state, selectedLink: payload };
    case types.SET_CATEGORY:
      return { ...state, category: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    case types.SET_CATEGORIES_IS_VISIBLE:
      return { ...state, categoriesIsVisible: payload };
    default:
      throw new Error();
  }
};
